var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDictionariesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2131 1.33359H4.78647C3.36647 1.33359 2.21313 2.49359 2.21313 3.90692V13.3003C2.21313 14.5003 3.07313 15.0069 4.12647 14.4269L7.3798 12.6203C7.72647 12.4269 8.28647 12.4269 8.62647 12.6203L11.8798 14.4269C12.9331 15.0136 13.7931 14.5069 13.7931 13.3003V3.90692C13.7865 2.49359 12.6331 1.33359 11.2131 1.33359Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39307 7.33308L7.39307 8.33308L10.0597 5.66641",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionariesIcon);
export default __webpack_public_path__ + "static/media/dictionaries-icon.305c87bbf66eabce18ddf9be27607631.svg";
export { ForwardRef as ReactComponent };